var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#7AB30E",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 24.4687L21.5781 17.5937C21.4835 17.5354 21.375 17.5033 21.2638 17.5008C21.1527 17.4984 21.0428 17.5256 20.9457 17.5797C20.8486 17.6339 20.7677 17.713 20.7113 17.8088C20.6549 17.9046 20.6251 18.0138 20.625 18.125V31.875C20.6251 31.9862 20.6549 32.0953 20.7113 32.1912C20.7677 32.287 20.8486 32.3661 20.9457 32.4202C21.0428 32.4744 21.1527 32.5016 21.2638 32.4991C21.375 32.4967 21.4835 32.4646 21.5781 32.4062L32.8203 25.5312C32.9126 25.4766 32.9891 25.3989 33.0423 25.3058C33.0954 25.2126 33.1233 25.1072 33.1233 25C33.1233 24.8927 33.0954 24.7873 33.0423 24.6942C32.9891 24.601 32.9126 24.5233 32.8203 24.4687Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8203 24.4687L21.5781 17.5937C21.4835 17.5354 21.375 17.5033 21.2638 17.5008C21.1527 17.4984 21.0428 17.5256 20.9457 17.5797C20.8486 17.6339 20.7677 17.713 20.7113 17.8088C20.6549 17.9046 20.6251 18.0138 20.625 18.125V31.875C20.6251 31.9862 20.6549 32.0953 20.7113 32.1912C20.7677 32.287 20.8486 32.3661 20.9457 32.4202C21.0428 32.4744 21.1527 32.5016 21.2638 32.4991C21.375 32.4967 21.4835 32.4646 21.5781 32.4062L32.8203 25.5312C32.9126 25.4766 32.9891 25.3989 33.0423 25.3058C33.0954 25.2126 33.1233 25.1072 33.1233 25C33.1233 24.8927 33.0954 24.7873 33.0423 24.6942C32.9891 24.601 32.9126 24.5233 32.8203 24.4687V24.4687Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.d90aa27b032b42f7210aa89110c63c3c.svg";
export { ForwardRef as ReactComponent };